import NewDistriView from '../components/NewDealerView/NewDealerView';
import { useLogicForm } from 'src/hooks/useLogicForm';
import ModalApprove from '../utils/ModalApprove/ModalApprove';
import Modal from '../utils/Modal/Modal';
import FullPageLoader from 'src/components/FullPageLoader/FullPageLoader';


/* Contenedor para agregar un nuevo distribuidor */
const NewDealer = () => {
  const {
    optionCountries,
    optionTypology,
    optionSociety,
    handleChange,
    handleAlert,
    handleSubmit,
    handleSave,
    handleOnBlur,
    error,
    addDealer,
    getTitle,
    user,
    isLoading,
    disabledInput
  } = useLogicForm();

  return (
    <>
      <NewDistriView
        optionCountries={optionCountries}
        optionTypology={optionTypology}
        optionSociety={optionSociety}
        handleChange={handleChange}
        handleAlert={handleAlert}
        handleSubmit={handleSubmit}
        handleSave={handleSave}
        handleOnBlur={handleOnBlur}
        error={error}
        addDealer={addDealer}
        getTitle={getTitle}
        user={user}
        disabledInput={disabledInput}
      />
      <FullPageLoader isLoading={isLoading} />
      <ModalApprove />
      <Modal />
    </>
  );
};

export default NewDealer;
